import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import { PaymentTypeInterface } from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeInterface";
import Searchbar from "../Searchbar/Searchbar";
import Time from "../../../Time/Time";
import Constants from "../../../Action/Constants";
import { BankAccountCreate } from "./BankAccountCreate";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import TextField from "../Material/TextField";
import Formatter from "../../../Localization/Formatter";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import Select from "../Material/Select";
import { PageTransition } from "../Spinner/PageTransition";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { CoachNewCounterpartyDialog } from "./CoachNewCounterpartyDialog";

export class QuickPaymentDialog extends Component {
  protected timer;

  public state = {
    amountForPayment: null,
    isOpen: false,
    charge: null,
    paymentDateQuickOption: new Date(),
    agencyBankAccountIdForPayment: null,
    descriptionForPayment: "",
    counterpartyIbanForPayment: "",
    currencyIdForPayment: this.props.app?.settings?.user?.currency?.getCurrencyId(),
    isSaving: false,
    showAllFields: false,
    payment: null,
    hasSettlementType: false,
    typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel("Bank")),
    agencyBankAccounts: [],
    isCreateBankAccountPopupOpen: false,
    paymentClassId: "",
		selectedCounterpartyForPayment: null,
    counterpartyIbanForPaymentIsManuallyChanged: false,
    typeNameForPayment: "Bank",
    openCoachCreateNewCounterparty: false   
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    const agencyBankAccounts: BankAccountInterface[] = this.getAgencyBankAccounts();

    const defaultBankAccount: BankAccountInterface = agencyBankAccounts.find(bankAccount => {
      return bankAccount.isDefault === true;
    });

    let agencyBankAccountId;

    if(!!defaultBankAccount) {
      agencyBankAccountId = !!defaultBankAccount ? defaultBankAccount.id : null;
    } else {
      agencyBankAccountId = !!agencyBankAccounts[0] ? agencyBankAccounts[0].id : null;
    }

    const agencyBankAccountsList = nextProps?.app?.bankAccounts
    .filter((bankAccount: BankAccountInterface) => bankAccount.companyId === this.getAgency()?.id);

    const currentBankAccount = agencyBankAccounts.find((bankAccount: BankAccountInterface) =>
                                                bankAccount.id === agencyBankAccountId);

    this.setState({
      agencyBankAccounts: !!currentBankAccount ?
      [...new Set([currentBankAccount, ...agencyBankAccountsList.filter(bankAccount => !bankAccount.removed)])] :
      agencyBankAccountsList.filter(bankAccount => !bankAccount.removed),
    })


    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen,
      });
    }

    if (nextProps.charge !== this.state.charge) {
      this.setState({
        charge: nextProps.charge
      }, () => {
        const chargeClassId: number = this.state.charge?.chargeClass?.id;

        this.setState({
          amountForPayment: Formatter.simpleFormatNumber(this.state.charge?.amountRemaining),
          agencyBankAccountIdForPayment: agencyBankAccountId,
          paymentClassId: String(chargeClassId),
          selectedCounterpartyForPayment: this.state.charge?.counterparty,
          descriptionForPayment: this.state.charge?.description
        })
      });
    }
  }

  public componentWillUnmount() {
    this.setState({
      charge: null,
      isOpen: false,
      showAllFields: false
    })
  }

  public save = (charge: ChargeInterface) => {
    if (!this.state.charge) {
      return;
    }

    const payment: any = {
      amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amountForPayment)).replace(",", ".")).toFixed(2)),
      amountRemaining: parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(this.state.amountForPayment)).replace(",", "."))).toFixed(2)),
      currencyId: this.state.currencyIdForPayment,
      currency: this.state.currencyIdForPayment,
      firstDateOfStatementPeriod: Time.formatOrNull(charge.firstDate),
      dateOfThePayment: Time.formatOrNull(this.state.paymentDateQuickOption),
      paymentTypeId: Number(this.state.typeIdForPayment),
      agencyBankAccount: this.state.typeNameForPayment === "Bank" ? this.state.agencyBankAccountIdForPayment : null,
      paymentClassId: Number(this.state.paymentClassId),
      description: this.state.descriptionForPayment
    };

    if (!!charge && charge.chargeClass.id !== payment.paymentClassId) {
      this.setState({ hasModifiedData: true, isSaving: false });

      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("preprocess/cannotpaycharge-info/differentclasses"),
          type: "warning"
        }
      });
    }

    if (!!charge) {
      payment.chargeIds = [charge.id];
    }

    if (this.state.selectedCounterpartyForPayment instanceof Person) {
      payment.contactId = this.state.selectedCounterpartyForPayment?.id;
    }

    if (this.state.selectedCounterpartyForPayment instanceof Company) {
      payment.companyId = this.state.selectedCounterpartyForPayment?.id;
    }
  
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_START,
        payload: {
          payment: payment
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
          this.setState({isSaving: false}, () => {
            this.clearState();
            this.props.closeDialog();
            this.props.initializePage(); 
          })
      
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
          // this.props.dispatch({
          //   type: Constants.SNACKBAR_ADD_MESSAGE,
          //   payload: {
          //     message: this.trans("cannotpaycharge-info/bankaccountmissing"),
          //     type: "error"
          //   }
          // });
        }
      });
    });
  }

  public clearState = () => {
    this.setState({
      amountForPayment: null,
      isOpen: false,
      charge: null,
      paymentDateQuickOption: new Date(),
      agencyBankAccountIdForPayment: null,
      descriptionForPayment: "",
      counterpartyIbanForPayment: "",
      currencyIdForPayment: this.props.app?.settings?.user?.currency?.getCurrencyId(),
      isSaving: false,
      showAllFields: false,
      payment: null,
      hasSettlementType: false,
      typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel("Bank")),
      agencyBankAccounts: [],
      isCreateBankAccountPopupOpen: false,
      paymentClassId: "",
      selectedCounterpartyForPayment: null,
      counterpartyIbanForPaymentIsManuallyChanged: false,
      typeNameForPayment: "Bank" 
    })
  }

  public selectDate = (date: Date, identifier: string): void => {
    this.setState({
      [identifier]: date, // todo fix hardcoded value
    });
  }

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      additionalSectionHasModifiedData: true
    });
  }

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForCharge: currency,
      hasModifiedData: true
    });
  }

  public changeView = () => {
    this.setState({
      showAllFields: !this.state.showAllFields,
    });
  }
  
  public changeTypeIdForPayment = (event): void => {
    const type = String(event.target.value);

    this.setState({
      typeNameForPayment: type == PaymentTypeContainer.pickIdFromLabel("Bank") ? "Bank" : null,
      typeIdForPayment: type,
      additionalSectionHasModifiedData: true,
    });
  }


  public updateAgencyBankAccountIdForPayment = (event): void => {
    const bankAccountId: number = event.target.value;

    if (bankAccountId) {
      this.setState({
        agencyBankAccountIdForPayment: bankAccountId,
        additionalSectionHasModifiedData: true
      });
    }
  }

  public openCreateBankAccountPopup = (): void => {
    this.setState({isCreateBankAccountPopupOpen: true})
  }

  public addBankAccount = (bankAccount: object): void => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
        payload: {
          bankAccount: bankAccount
        },
        onSuccess: (bankAccount: BankAccountInterface) => {
          this.setState({
            isSaving: false,
            isCreateBankAccountPopupOpen: false,
            agencyBankAccountIdForPayment: bankAccount.id
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public changePaymentClassId = (event): void => {
    const paymentClassId = String(event.target.value);

    this.setState({
      paymentClassId: paymentClassId,
    });
  }

  public selectCounterpartyForPayment = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      selectedCounterpartyForPayment: entity,
      hasModifiedData: true
    });
  }

  public clearCounterpartyForPayment = (): void => {
    this.setState({
      selectedCounterpartyForPayment: null,
      hasModifiedData: true
    });
  }

  public changeCounterpartyIbanForPayment = (event): void => {
    const counterpartyIbanForPayment: string = event.target.value;

    this.setState({
      counterpartyIbanForPayment: counterpartyIbanForPayment,
      counterpartyIbanForPaymentWasChanged: true,
      additionalSectionHasModifiedData: true
    });
  }

  public changeDescriptionForPayment = (event): void => {
    const description: string = event.target.value;
    this.setState({
      descriptionForPayment: description,
      descriptionForPaymentIsManuallyChanged: true,
    });
  }

  public renderContent = () => {
    return (
      <div style={{width: "420px"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
        <div style={{display: "flex", flexDirection: "column", width: "70%", marginRight: "10px"}}>
          <TextField
            // id="аmountForPayment"
            type="text"
            value={this.state.amountForPayment}
            onChange={this.changeAmountForPayment}
            autoFocus={true}
            className="form-size scroll-to-amountForPayment"
            style={{marginRight: "30px"}}
            label={this.trans("section/payment-field/аmount-label")}
            helperText={this.getErrorFor("amountForPayment")}
            error={!!this.getErrorFor("amountForPayment")}
          />
          {/* {!!this.getErrorFor("amountForPayment") &&  <div className="component-error-text">{this.getErrorFor("amountForPayment")}</div>} */}
          </div>

          <Select
            className="form-input scroll-to-currencyIdForCharge"
            style={{width: "30%"}}
            error={this.getErrorFor("currencyIdForCharge")}
            value={this.state.currencyIdForPayment}
            onChange={this.changeCurrencyIdForCharge}
            htmlFor="currencyIdForCharge"
            name="currencyIdForCharge" 
            id="currencyIdForCharge"
          >
            {this.getCurrencySelectboxes()}
          </Select>
        </div>

        <DatePickerComponent
          {...this.props}
          id="firstDateOfStatementPeriodForPayment"
          name="firstDateOfStatementPeriodForPayment"
          className="scroll-to-firstDateOfStatementPeriodForPayment"
          label={this.trans("payment-date")}
          initialDate={this.state.paymentDateQuickOption}
          onChange={date => this.selectDate(date, "paymentDateQuickOption")}
          clearButton={true}
          error={this.getErrorFor("firstDateOfStatementPeriodForPayment")}
        />
        <div 
					style={{
						width: "40px",
						display: "flex",
            alignItems: "center",
            cursor: "pointer"
          }} 
          onClick={this.changeView}
				>
					{
						this.state.showAllFields ? 
              <ExpandLess style={{marginTop: "-7px"}} /> :
              <ExpandMore style={{marginTop: "-7px"}} />
					}
          <div>{this.trans("label-more")}</div>
				</div>

        {
          this.state.showAllFields && 
          <div>
             {
						!this.state.hasSettlementType && PaymentTypeContainer.pickIdFromLabel("Savings_account") === this.state?.payment?.paymentType?.id &&
            (
              <RadioGroup
                name="typeFilters"
                className="filters-container"
                value={this.state.typeIdForPayment}
                onChange={this.changeTypeIdForPayment}
                style={{paddingLeft: "0px", width: "auto", margin: "0"}}
              >
                {
									PaymentTypeContainer.getInstances()
										.filter((paymentType: PaymentTypeInterface) => {
                      return paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Settlement") 
                      && paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Cheque")  
										})
                    .map((paymentType: PaymentTypeInterface, index: number) => {
                        return (
                          <FormControlLabel
                            control={<Radio color="primary" />}
                            key={`paymentTypeId-${index}`}
                            value={String(paymentType.id)}
                            label={this.trans(`payment_type_${paymentType.label}`)}
                            style={{fontSize: "16px"}}
                          />
                        );
                      })
                }
              </RadioGroup>
            )
					}

					{
						!this.state.hasSettlementType && !(PaymentTypeContainer.pickIdFromLabel("Savings_account") === this.state?.payment?.paymentType?.id) &&
            (
              <RadioGroup
                name="typeFilters"
                className="filters-container"
                value={this.state.typeIdForPayment}
                onChange={this.changeTypeIdForPayment}
                style={{paddingLeft: "0px", width: "auto", margin: "0"}}
              >
                {
									PaymentTypeContainer.getInstances()
										.filter((paymentType: PaymentTypeInterface) => {
                      return paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Settlement") 
                      && paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Cheque") 
                      && paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Savings_account")
 
										})
                    .map((paymentType: PaymentTypeInterface, index: number) => {
                        return (
                          <FormControlLabel
                            control={<Radio color="primary" />}
                            key={`paymentTypeId-${index}`}
                            value={String(paymentType.id)}
                            label={this.trans(`payment_type_${paymentType.label}`)}
                            style={{fontSize: "16px"}}
                          />
                        );
                      })
                }
              </RadioGroup>
            )
					}

          {
						this.state.hasSettlementType && !(PaymentTypeContainer.pickIdFromLabel("Savings_account") === this.state?.payment?.paymentType?.id) &&
            (
              <RadioGroup
                name="typeFilters"
                className="filters-container"
                value={this.state.typeIdForPayment}
                onChange={this.changeTypeIdForPayment}
                style={{paddingLeft: "0px", width: "auto", margin: "0"}}
              >
                {
                  PaymentTypeContainer.getInstances()
                  .filter((paymentType: PaymentTypeInterface) => {
                    return paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Cheque")  
                    && paymentType.id !== PaymentTypeContainer.pickIdFromLabel("Savings_account")
                    })
                    .map((paymentType: PaymentTypeInterface, index: number) => {
                        return (
                          <FormControlLabel
                            control={<Radio color="primary" />}
                            key={`paymentTypeId-${index}`}
                            value={String(paymentType.id)}
                            label={this.trans(`payment_type_${paymentType.label}`)}
                            style={{fontSize: "16px"}}
                          />
                        );
                      })
                }
              </RadioGroup>
            )
					}

					{Number(this.state.typeIdForPayment) === PaymentTypeContainer.pickIdFromLabel("Bank")  && (
						<Select
							className="form-element full-size form-input bank-account-wrapper scroll-to-agencyBankAccountIdForPayment correct-label-position"
							variant="standard"
							error={this.getErrorFor("agencyBankAccountIdForPayment")}
							name="agencyBankAccountIdForPayment"
							// id="agencyBankAccountIdForPayment"
							value={!!this.state.agencyBankAccountIdForPayment ? this.state.agencyBankAccountIdForPayment : ""}
							onChange={this.updateAgencyBankAccountIdForPayment}
							htmlFor="agencyBankAccountIdForPayment"
							label={this.trans("section/payment-field/bankaccount-label")}
						>
							{
								this.state.agencyBankAccounts
									.map((bankAccount: BankAccountInterface, key: number) => {
										return (
											<MenuItem
												key={`bankAccount-${key}`}
												value={bankAccount.id}
												className="filter-payment-item"
											>
											<div className="bank-account-menuitem-wrapper" style={{height: "23px"}}>
												<div>{`${bankAccount.accountId ? `${bankAccount.accountId}` : ""} ${bankAccount.name !== "" && bankAccount.name ? ` - ${bankAccount.name}` : ""}`}</div>
											</div>
											</MenuItem>
										);
									})
							}
							<MenuItem
								className="button-add-wrapper">
								<Button
									className="color-button-add"
									style={{width: "100%"}}
									onClick={this.openCreateBankAccountPopup}
								>
									{this.trans("dropdown/bankaccount-button/newbankaccount")}
								</Button>
							</MenuItem>
						</Select>
					)}

					<div>
						<div className="search-bar-container" style={{margin: "-20px 0 -10px 0"}}>
              <Searchbar
                {...this.props}
                id="selectedCounterpartyForPayment"
                className={"scroll-to-counterpartyId"}
                // floatingLabelText={labelText}
                floatingLabelText={Number(this.state.paymentClassId) == PaymentClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/from-label") : this.trans("section/charge-field/to-label")}
                allResults={true}
                objectField={true}
                onChange={this.selectCounterpartyForPayment}
                onClear={this.clearCounterpartyForPayment}
                selectedEntity={this.state.selectedCounterpartyForPayment}
                searchParameter={"contactsSearch"}
                error={this.getErrorFor("counterpartyId")}
                searchText={this.state.selectedCounterpartyForPayment ? `${this.state.selectedCounterpartyForPayment.nameOfEntity}, ${this.state.selectedCounterpartyForPayment.displayName}` : null}
                styleInModal={"pick-object-modal"}
                createButton={"dropdown-button/newcounterparty"}
                openCoachCreateNewEntity={() => {
                  this.setState({
                    openCoachCreateNewCounterparty: true,
                    selectedCounterparty: null
                  })}
                }
              />
            </div>
					</div>

					<TextField
						autoComplete="off"
						id="descriptionForPayment"
						name="descriptionForPayment"
						className="form-element full-size scroll-to-descriptionForPayment"
						type="text"
						label={this.trans("section/payment-sub/banktransaction-field/description-label") + this.trans("field/optional")}
						value={this.state.descriptionForPayment}
						onChange={this.changeDescriptionForPayment}
						variant="standard"
						multiline={true}
						rowsMax={10}
						error={!!this.getErrorFor("descriptionForPayment")}
					/>
					{!!this.getErrorFor("descriptionForPayment") && <div className="component-error-text">{this.getErrorFor("descriptionForPayment")}</div>}
          </div>
        }
      </div>
    );
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpen}
          title={this.trans("page/chargeupdate-preprocess/paythischarge-title")}
          subtitle={this.state.charge?.displayName || ""}
          content={this.renderContent()}
          positiveButtonLabel={this.trans("dialog-button/finish")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.save(this.state.charge)}
          onDiscard={() => {
              this.clearState();
              this.props.closeDialog();
            }
          }
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/bankaccount-title")}
          content={
          <BankAccountCreate
            {...this.props}
            onSave={this.addBankAccount}
            onClose={() => this.setState({isCreateBankAccountPopupOpen: false})}
          />}
          openLeavePrompt={this.state.isCreateBankAccountPopupOpen}
          onClose={() =>{
            this.setState({isCreateBankAccountPopupOpen: false})
            this.props.dispatch({
              type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR,
            })
          }}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.selectCounterpartyForPayment(entity)})
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
